import { Switch } from 'element-ui'

const YSwitch = Switch
YSwitch.$depends = [Switch]
YSwitch.$name = 'y-switch'
YSwitch._name = 'Switch 开关'

export default YSwitch
